import { AsyncThunk, createAsyncThunk } from '@reduxjs/toolkit';
import { SERVICES, HttpMethods } from '../../../services/api';
import { basicApiAsyncThunkCreator } from '../../../services/apiAsyncThunkCreator';
import { ThunkAPI } from '../../rootReducer';
import { Features, isFeatureEnabled } from '../../../featureToggles/features';
import { IPreviewEnterpriseLicenseCost, IPreviewEnterpriseLicenseCostData, IPreviewEnterpriseLicenseCostParams } from './interfaces';

export const PREVIEW_ENTERPRISE_LICENSE_COST_THUNK_PREFIX = 'account/fetchPreviewEnterpriseLicenseCost';
export const fetchPreviewEnterpriseLicenseCost: AsyncThunk<IPreviewEnterpriseLicenseCost | void, IPreviewEnterpriseLicenseCostParams, ThunkAPI> =
  createAsyncThunk(
    PREVIEW_ENTERPRISE_LICENSE_COST_THUNK_PREFIX,
    async (data, thunk) => {
      if (!isFeatureEnabled(Features.PlgExternal3)) {
        thunk.dispatch({
          type: 'DO_NOTHING'
        });
        return;
      }
      try {
        const response = await basicApiAsyncThunkCreator<IPreviewEnterpriseLicenseCost | void, IPreviewEnterpriseLicenseCostData>({
          endpoint: `accounts/${data.accountId}/preview-enterprise-license-cost`,
          microservice: SERVICES.USERS_SERVICE,
          authenticated: true,
          method: HttpMethods.Post,
          contentType: 'application/json'
        })({
          licenseAdditionDealId: data.licenseAdditionDealId
        }, thunk);
        return response;
      } catch (err) {
        return thunk.rejectWithValue(err);
      }
    }
  );
